import { getSearchWith } from "@/utils/searchHelper"
import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"

type Value = string | string[] | null

interface UseSingleFilterResult {
  value: Value
  filtersKey: string
  setValue: (value: Value) => void
  resetValue: () => void
}

export const useSingleFilterParam = (key: string): UseSingleFilterResult => {
  const [searchParams, setSearchParams] = useSearchParams()

  const allValues = searchParams.getAll(key)
  const value: Value = allValues.length > 1 ? allValues : (searchParams.get(key) ?? null)

  const setValue = useCallback(
    (value: Value) => {
      const params: Record<string, Value> = {}

      params[key] = value

      setSearchParams(getSearchWith(searchParams, params))
    },
    [searchParams, setSearchParams, key]
  )

  const resetValue = useCallback(() => {
    setSearchParams(getSearchWith(searchParams, { [key]: null }))
  }, [searchParams, setSearchParams, key])

  const filtersKey = searchParams.toString()

  return { value, setValue, resetValue, filtersKey }
}
